(function () {
  'use strict';

  function formatMoney(cents, format) {
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || (window.themeMoneyFormat || '{{amount}} kr.');

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = typeof precision === 'undefined' ? 2 : precision;
      thousands = typeof thousands === 'undefined' ? '.' : thousands;
      decimal = typeof decimal === 'undefined' ? ',' : decimal;

      if (isNaN(number) || number == null) return 0;

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    var match = formatString.match(placeholderRegex);
    var key = match ? match[1] : 'amount';

    switch (key) {
      case 'amount_no_decimals':
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0);
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return match ? formatString.replace(placeholderRegex, value) : value + ' kr.';
  }

  function initFbt(root) {
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-fbt-item]'));
    var totalEl = root.querySelector('[data-fbt-total]');
    var ctaButton = root.querySelector('[data-fbt-submit]');
    var ctaLabelEl = root.querySelector('[data-fbt-cta-label]');
    var statusEl = root.querySelector('[data-fbt-status]');
    var baseCtaLabel = ctaLabelEl ? ctaLabelEl.textContent.trim() : 'Læg {count} i kurv';

    function buildCtaLabel(count) {
      if (baseCtaLabel.indexOf('{count}') !== -1) {
        return baseCtaLabel.replace('{count}', count);
      }
      return baseCtaLabel + ' (' + count + ')';
    }

    function currentSelect(item) {
      return item.querySelector('[data-fbt-variant-select]');
    }

    function currentVariantId(item) {
      var select = currentSelect(item);
      if (select) return select.value;
      return item.getAttribute('data-fbt-variant-id');
    }

    function currentPrice(item) {
      var select = currentSelect(item);
      if (select) {
        var opt = select.options[select.selectedIndex];
        return parseInt(opt.getAttribute('data-price'), 10) || 0;
      }
      return parseInt(item.getAttribute('data-fbt-price'), 10) || 0;
    }

    function updatePriceDisplay(item) {
      var priceEl = item.querySelector('[data-fbt-price-display]');
      if (priceEl) priceEl.textContent = formatMoney(currentPrice(item));
    }

    function recalc() {
      var total = 0;
      var count = 0;

      items.forEach(function (item) {
        var checkbox = item.querySelector('[data-fbt-checkbox]');
        if (checkbox && checkbox.checked) {
          total += currentPrice(item);
          count += 1;
        }
      });

      if (totalEl) totalEl.textContent = formatMoney(total);

      if (ctaLabelEl) {
        ctaLabelEl.textContent = count > 0 ? buildCtaLabel(count) : 'Vælg mindst ét produkt';
      }

      if (ctaButton) ctaButton.disabled = count === 0;
    }

    items.forEach(function (item) {
      var checkbox = item.querySelector('[data-fbt-checkbox]');
      var select = currentSelect(item);

      if (checkbox) checkbox.addEventListener('change', recalc);

      if (select) {
        select.addEventListener('change', function () {
          updatePriceDisplay(item);
          recalc();
        });
      }
    });

    if (ctaButton) {
      ctaButton.addEventListener('click', function () {
        if (ctaButton.disabled) return;

        var lineItems = [];

        items.forEach(function (item) {
          var checkbox = item.querySelector('[data-fbt-checkbox]');
          if (checkbox && checkbox.checked) {
            var variantId = currentVariantId(item);
            if (variantId) lineItems.push({ id: parseInt(variantId, 10), quantity: 1 });
          }
        });

        if (lineItems.length === 0) return;

        ctaButton.disabled = true;
        ctaButton.classList.add('loading');

        if (statusEl) {
          statusEl.hidden = true;
          statusEl.removeAttribute('data-state');
        }

        var addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
        if (addUrl.indexOf('.js') === -1) addUrl += '.js';

        fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: lineItems })
        })
          .then(function (response) {
            return response.json().then(function (data) {
              if (!response.ok) throw data;
              return data;
            });
          })
          .then(function () {
            if (statusEl) {
              statusEl.textContent = lineItems.length === 1
                ? 'Lagt i kurven.'
                : lineItems.length + ' produkter lagt i kurven.';
              statusEl.hidden = false;
              statusEl.setAttribute('data-state', 'success');
            }

            document.dispatchEvent(new CustomEvent('cart:refresh'));

            var cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && typeof cartDrawer.updateAndOpen === 'function') {
              cartDrawer.updateAndOpen();
              return;
            }

            fetch('/?section_id=cart-icon-bubble')
              .then(function (res) { return res.text(); })
              .then(function (html) {
                var bubble = document.getElementById('cart-icon-bubble');
                if (!bubble) return;
                var doc = new DOMParser().parseFromString(html, 'text/html');
                var replacement = doc.querySelector('.shopify-section');
                if (replacement) bubble.innerHTML = replacement.innerHTML;
              })
              .catch(function () {});
          })
          .catch(function (error) {
            if (statusEl) {
              statusEl.textContent = (error && error.description) || 'Noget gik galt. Prøv igen.';
              statusEl.hidden = false;
              statusEl.setAttribute('data-state', 'error');
            }
          })
          .finally(function () {
            ctaButton.disabled = false;
            ctaButton.classList.remove('loading');
          });
      });
    }

    recalc();
  }

  document.querySelectorAll('[data-fbt]').forEach(initFbt);
})();
